export default "__VITE_ASSET__ORf4ETuL__"